import Head from "next/head";
import { LandingPageProps } from "./types";

const PreloadImages = (pageProps: LandingPageProps) => {
  return (
    <Head>
      {pageProps?.data?.claimSettlementText?.icon && (
        <link
          rel="preload"
          href={`${pageProps.data.claimSettlementText.icon}`}
          as="image"
        />
      )}
      {pageProps?.data?.travelSearchBanner?.icon && (
        <link
          rel="preload"
          href={`${pageProps.data.travelSearchBanner.icon}`}
          as="image"
        />
      )}
      {pageProps?.data?.secureTravData?.[0]?.travImg && (
        <link
          rel="preload"
          href={`${pageProps.data.secureTravData[0].travImg}`}
          as="image"
        />
      )}
      {pageProps?.data?.secureTravData?.[1]?.travImg && (
        <link
          rel="preload"
          href={`${pageProps.data.secureTravData?.[1].travImg}`}
          as="image"
        />
      )}
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Frame_27565_cc0104059a.png"
        as="image"
      />
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg"
        as="image"
      />
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg"
        as="image"
      />
      {/* TODO: Use compressed svg directly inline */}
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_2e09571187.svg"
        as="image"
      />
      <link
        rel="preload"
        href="https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_db78b6056e.svg"
        as="image"
      />
    </Head>
  );
};

export default PreloadImages;
